import styled from 'styled-components'
import { Form, Input } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import { CommonProps } from '.'
import { FormInstance } from 'antd/es/form'
import { BlockButton } from './direct-login'
import { setConfirmPassword } from './util'
import { t } from '@/i18n'
const { useForm } = Form
interface FirstLoginProps extends CommonProps {
  setoldpassword: (password: string) => void
}

export const FirstLogin: React.FC<FirstLoginProps> = ({ setLoginStatus, setoldpassword }) => {
  const formRef = React.createRef<FormInstance>()
  const [form] = useForm()
  const [confirmPassword, confirmPasswordLoading] = setConfirmPassword()
  const toResetPwd = () => {
    setLoginStatus('first-reset-pwd')
  }

  const onFinish = value => {
    //1:是2否    是否是主账号
    // localStorage.getItem('active') * 1
    confirmPassword({
      password: value?.pwd,
    })
      .then(() => {
        toResetPwd()
        setoldpassword(value?.pwd)
      })
      .catch(_ => {})
  }
  return (
    <Content>
      <Form form={form} ref={formRef} onFinish={onFinish}>
        <Form.Item name="pwd" rules={[{ required: true, message: t('请输入旧密码') }]}>
          <Input.Password
            placeholder={t('确认旧密码')}
            prefix={<UserOutlined style={{ color: '#333333' }} />}
            maxLength={120}
          />
        </Form.Item>
        <BlockButton
          block
          className="loginBtn"
          loading={confirmPasswordLoading}
          type={'primary'}
          onClick={form.submit}
        >
          {t('确定')}
        </BlockButton>
      </Form>
    </Content>
  )
}

const Content = styled.div`
  .ant-btn-primary {
    background: #4238c9;
  }
  .ant-input-affix-wrapper,
  .ant-input {
    border-color: #d9d9d9;
    &:hover {
      border-color: #4238c9;
    }
  }
  input:-webkit-autofill,
  textarea:-webkit-autofill,
  select:-webkit-autofill {
    background-image: none;
    transition: background-color 50000s ease-in-out 0s;
  }
  .send {
    height: 38px;
    color: #fff;
    background: #4238c9;
    border: 1px solid #4238c9;
    &:hover {
      background: linear-gradient(320deg, #4238c9 0%, #675fd3 100%);
      border: none;
    }
  }
`
